__turbopack_context__.v({
  "label": "IJiNgW_label",
  "nestedList": "IJiNgW_nestedList",
  "nestedSubMenu": "IJiNgW_nestedSubMenu",
});
